/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { I18NDto } from '../../models/i-18-n-dto';

export interface I18NAdminControllerFindByIdV1$Params {
  id: string;
}

export function i18NAdminControllerFindByIdV1(http: HttpClient, rootUrl: string, params: I18NAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<I18NDto>> {
  const rb = new RequestBuilder(rootUrl, i18NAdminControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<I18NDto>;
    })
  );
}

i18NAdminControllerFindByIdV1.PATH = '/api/v1/i18n/admin/{id}';
